import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction<string>('auth/UPDATE_TIMEZONE'));
